module.exports = __webpack_public_path__ + "static/media/pork-explore-more.4ee39139.jpg";